import * as React from "react";
import useIsMobile from "src/hooks/useIsMobile";
import { Background, Container } from "src/components/shared/Modal/ModalContainer.components";
import { ModalState } from "src/components/shared/Modal/ModalProvider";
import { ModalContentType } from "./ModalProvider";

interface ModalContainerProps extends ModalState {
  onBackgroundClick: (event: React.MouseEvent) => void;
  children?: ModalContentType;
}
const ModalContainer: React.FunctionComponent<ModalContainerProps> = ({
  children,
  state,
  onBackgroundClick,
}) => {
  const isMobile = useIsMobile();
  return (
    <>
    {!isMobile && <Background state={state} />}
    <Container state={state} onClick={onBackgroundClick}>
      {/* Pass extra status prop to children element */}
      {children && <children.type {...children.props} state={state} />}
    </Container>
    </>

  );
};

export default ModalContainer;
